<template>
  <div>
    <div>
       <div class="head_img"> 
         <img :src="heads.avatar" style="width: 100px; height: 100px;">
      </div>
      <div class="head_name">
           <span> {{ heads.name }}</span> 
      </div>
      <div class="vs">
        <ul class="head_vs">
          <li> 上次的你 </li> 
          <li> 这次的你 </li> 
        </ul> 
      </div>
    </div>
    <div class="hello">
      <div class="score">
        <ul class="score_date">
          <li>{{ heads.score_date[0] }}</li> 
          <li>{{ heads.score_date[1] }}</li> 
        </ul>  
        <ul class="score_value">
            <li>{{ heads.score_value[0] }} <span class="per">分</span></li> 
            <li>{{ heads.score_value[1] }} <span class="per">分</span></li> 
        </ul>
      </div>
    </div> 
  </div>
</template>

<script>
export default {
  // 接收父组件传过来的属性
  props: ['heads', 'avatar', 'sdate', 'value']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 
.head_img{
    display: inline-block;
    width: 95px;
    height: 95px;
    margin-top: 10px;
    margin-bottom: 1px;
    background: rgba(16, 0, 0, 0.2);
    border-radius: 50%;
    padding: 0px;
    overflow: hidden;
}

.head_name{
    color: #000;
    font-size: 18px;
    padding: 10px; 
}
 
 .score{
    color: #000;
    font-size: 22px;
    vertical-align: middle;
    font-weight: 200;
 }
 
  .vs{
    color: #999999;
    font-size: 20px;
    vertical-align: middle;
    font-weight: 200;
 }

.vs li{
   width: 140px;
   vertical-align: middle; 
   padding-top: 4px;
 }

  .head_vs{
  color: #999999;
  background-image: url('~assets/images/vs.png');
  background-position: center;
  background-size:32px 32px;
  background-repeat: no-repeat; 
  padding-bottom:  4px;
 }

 .score li{
   width: 136px;
   vertical-align: middle; 
   padding-top: 6px
 }

 .score_date{
  color: #0FBFEF;
   font-size: 20px;
  background-image: url('~assets/images/accow_blue.png');
  background-position: center;
  background-size:24px 16px;
  background-repeat: no-repeat; 
 }

  .score_value{
  color: #999999
 }

 .score_value .per{
   font-size: 18px;
 }
</style>



// WEBPACK FOOTER //
// Hello.vue?7ce15344